module.exports = __webpack_public_path__ + "img/7a6d436.jpg";